<div class="container-fluid p-3">
  <div
    class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3 mb-3 flex-wrap">
    <!-- Title aligned to the right on larger screens -->
    <h4 class="m-0 text-md-end text-start text-color fs-24 fg-500">
      {{ 'ADMIN.THEMES' | translate }}
    </h4>

    <!-- Ajout : action de l'écran, indépendante des facettes. -->
    <app-button (click)="addTheme()" [label]="'ADMIN.ADD_THEME' | translate"
      [customClasses]="'fs-14 fg-600 py-2 px-5 btn-create-test'" [type]="'button'" />
  </div>

  <!-- Filtres harmonisés (banque de questions) : parcours → matière, cumulables -->
  <app-filter-bar class="mb-4 d-block"
    [activeCount]="activeFilterCount"
    [resultCount]="visibleThemes.length"
    [totalCount]="themes.length"
    [search]="search"
    searchPlaceholderKey="FILTERS.SEARCH_THEME_PLACEHOLDER"
    (searchChange)="onSearchChange($event)"
    (reset)="resetFilters()">

    <app-searchable-select
      [options]="pathOptions" [value]="selectedPathId"
      [allLabel]="'FILTERS.ALL_PATHS' | translate"
      [placeholder]="'ADMIN.SELECT_PATH' | translate" icon="fa-solid fa-route"
      [disabled]="isLoadingPaths"
      (valueChange)="onPathChange($event)">
    </app-searchable-select>

    <app-searchable-select
      [options]="subjectOptions" [value]="selectedSubjectId"
      [allLabel]="'FILTERS.ALL_SUBJECTS' | translate"
      [placeholder]="'ADMIN.SELECT_SUBJECT' | translate" icon="fa-solid fa-book"
      [disabled]="isLoadingSubjects || subjectOptions.length === 0"
      (valueChange)="onSubjectChange($event)">
    </app-searchable-select>
  </app-filter-bar>

  <!-- Loading State -->
  <div *ngIf="isLoading" class="text-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">{{ 'COMMON.LOADING' | translate }}</span>
    </div>
    <p class="mt-3">{{ 'COMMON.LOADING' | translate }}</p>
  </div>

  <!-- Error State -->
  <div *ngIf="error && !isLoading" class="alert alert-danger" role="alert">
    <i class="fa-solid fa-circle-exclamation me-2"></i>
    {{ error }}
    <button type="button" class="btn btn-sm btn-outline-danger ms-3" (click)="loadThemes()">
      <i class="fa-solid fa-rotate-right me-1"></i>
      {{ 'COMMON.RETRY' | translate }}
    </button>
  </div>

  <!-- Data Table -->
  <app-custom-tab *ngIf="!isLoading && !error && visibleThemes.length > 0" [data]="visibleThemes"
    [columns]="themeColumns" [toolbar]="tableToolbar"
    [actionTemplate]="themeActionsTemplate" [locale]="currentLocale" [enableRtl]="isRTL"
    (rowClick)="handleRowClick($event)">

    <!-- Define the actions template here with stopPropagation -->
    <ng-template #themeActionsTemplate let-data>
      <button class="btn btn-sm btn-primary mx-1" (click)="onEditTheme(data); $event.stopPropagation()"
        [title]="'COMMON.EDIT' | translate">
        <i class="fa-solid fa-pen-to-square"></i>
      </button>
      <button class="btn btn-sm btn-danger mx-1" (click)="onDeleteTheme(data); $event.stopPropagation()"
        [title]="'COMMON.DELETE' | translate">
        <i class="fa-solid fa-trash-can"></i>
      </button>
      <button class="btn btn-sm btn-secondary mx-1" (click)="onShowTheme(data); $event.stopPropagation()"
        [title]="'COMMON.VIEW' | translate">
        <i class="fa-solid fa-eye"></i>
      </button>
    </ng-template>
  </app-custom-tab>

  <!-- Empty State -->
  <div *ngIf="!isLoading && !error && visibleThemes.length === 0" class="text-center py-5">
    <i class="fa-solid fa-folder-open fa-3x text-muted mb-3"></i>
    <!-- « Aucun axe » et « aucun axe pour ces filtres » ne sont pas la même
         nouvelle : la seconde se règle en réinitialisant, pas en créant. -->
    <p class="text-muted">
      {{ (activeFilterCount > 0 ? 'FILTERS.EMPTY_TITLE' : 'ADMIN.NO_THEMES_FOUND') | translate }}
    </p>
    <app-button *ngIf="activeFilterCount === 0" (click)="addTheme()"
      [label]="'ADMIN.CREATE_FIRST_THEME' | translate"
      [customClasses]="'fs-14 fg-600 py-2 px-4 btn-create-test'" [type]="'button'" />
  </div>
</div>

<!-- ADD/EDIT THEME MODAL -->
<app-modal [title]="(isEditMode ? 'ADMIN.EDIT_THEME' : 'ADMIN.ADD_THEME') | translate" [size]="'lg'"
  [show]="showThemeModal" [hasFooter]="false" (closed)="onModalClosed()">
  <app-add-theme [theme]="selectedTheme" [isEditMode]="isEditMode" [subjectId]="selectedSubjectId"
    [subjects]="subjects"
    (saved)="handleThemeSaved($event)" (cancelled)="onModalClosed()">
  </app-add-theme>
</app-modal>
